import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import type { Props as ButtonProps } from '#src/atoms/buttons/Button/index.tsx';
import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconFilter } from '#src/atoms/icons/system/iconFilter.ts';
import { BodyM } from '#src/atoms/typography/index.tsx';
import { filters } from '#src/lib/glossary.ts';

const StyledButton = styled(Button)`
  margin: auto;
`;

const StyledText16 = styled(BodyM)`
  display: inline-flex;
  gap: var(--half-unit);
`;

type Props = {
  onClick: () => void;
  filtersCount?: number;
  className?: string;
} & Partial<Pick<ButtonProps, 'color' | 'size'>>;

export const FilterButton = ({
  onClick,
  filtersCount = 0,
  className,
  color = 'secondary',
  ...otherProps
}: Props) => {
  return (
    <StyledButton
      color={color}
      onClick={onClick}
      title="Toggle filters"
      startIcon={<FontAwesomeIcon icon={iconFilter} />}
      size="small"
      className={className}
      {...otherProps}
    >
      <StyledText16 bold>
        <FormattedMessage {...filters.filters} />
        {filtersCount > 0 && <span>({filtersCount})</span>}
      </StyledText16>
    </StyledButton>
  );
};
